var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { downpayment_percent, loan_type, mortgage_percent, rate_table_link } = options; 
__p+='\n\n<span class="display-block">\n  <span class="font-semibold">'+
((__t=( downpayment_percent ))==null?'':__t)+
'</span>\nDown Payment\n</span>\n<span class="font-semibold">'+
((__t=( loan_type ))==null?'':__t)+
'</span>\nLoan at\n<span class="font-semibold">'+
((__t=( mortgage_percent ))==null?'':__t)+
'</span>\n<div class="view-rates-xxs view-rates-xxxs view-se">\n  <a class="ldp-rate-table-link js-trigger-view-rates" href="'+
((__t=( rate_table_link ))==null?'':__t)+
'" target="_blank" rel="nofollow"  data-omtag="ldp:mortgage:view-rates">\n    View Today\'s Rates\n  </a>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/ldp_view_rates_cta.jst.ejs